//获取活动列表
const getActivityListUrl = `/gateway/hc-serve/miniapi/activity/activityList`;
//获取活动详情
const getActivityDetailUrl = `/gateway/hc-serve/miniapi/activity/activityDetail`;
//新增参与人
const addPeopleUrl = `/gateway/hc-serve/miniapi/activity/myApplicantsAdd`;
// 编辑参与人
const editPeopleUrl = `/gateway/hc-serve/miniapi/activity/myApplicantsEdit`;
//我的活动参与人列表
const addPeopleListUrl = `/gateway/hc-serve/miniapi/activity/myActivityApplicantsList`;
//我的活动参与人详情
const addPeopleDetailUrl = `/gateway/hc-serve/miniapi/activity/myActivityApplicantsDetail`;
//删除活动参与人
const deletePeopleUrl = `/gateway/hc-serve/miniapi/activity/myActivityApplicantsDelete`;
//活动报名
const applyActivityUrl = `/gateway/hc-serve/miniapi/activity/activityApply`;
// 取消报名
const cancelActivityUrl = `/gateway/hc-serve/miniapi/activity/cancelActivityApply`;
// 我报名的活动详情
const activityDetailUrl = `/gateway/hc-serve/miniapi/activity/myActivityDetail`;
//我的报名
const myActivityUrl = `/gateway/hc-serve/miniapi/activity/myActivityList`;
//发布活动共
const publishActivityUrl = `/gateway/hc-serve/miniapi/activity/postActivity`;
//我发布的活动列表
const myPublishActivityUrl = `/gateway/hc-serve/miniapi/activity/myActivityApplyList`;
// 我发布的活动详情
const activityApplyInfoUrl = `/gateway/hc-serve/miniapi/activity/activityApplyInfo`;
// 新接口 参与活动
// const applyActivityUrl = `/gateway/hc-serve/miniapi/activity/v1/activityApply`;

//场所列表
const areaListUrl = `/gateway/hc-serve/miniapi/activity/reservationPlaceList`;

//个人信息
const userInfoUrl = `/gateway/hc-mini/user/mini/user-info`;

/** 时间银行 */
// 验证志愿者身份接口
const volunteerUrl = `/gateway/hc-serve/miniapi/volunteer/verificationVolunteer`;
// 申请志愿者接口
const appliyVolunteerUrl = `/gateway/hc-serve/miniapi/volunteer/volunteerApplication`;
// 承诺书详情接口
const getCommitmentLetterDetailsUrl = `/gateway/hc-serve/miniapi/volunteer/commitmentLetterDetails`;
// 是否签署承诺书
const ifCommitmentLetterUrl = `/gateway/hc-serve/miniapi/volunteer/ifCommitmentLetter`;
// 签署承诺书接口
const applyForCommitmentLetterUrl = `/gateway/hc-serve/miniapi/volunteer/applyForCommitmentLetter`;
// 我的家庭成员列表接口
const getMyFamilyMemberListUrl = `/gateway/hc-serve/miniapi/volunteer/myFamilyMemberList`;
// 添加家庭成员
const addFamilyMemberUrl = `/gateway/hc-serve/miniapi/volunteer/addFamilyMember`;
// 删除家庭成员接口
const deleteFamilyMemberUrl = `/gateway/hc-serve/miniapi/volunteer/deleteFamilyMember`;

// 参与人备注编辑接口
const compileApplicantsNoteUrl = `/gateway/hc-serve/miniapi/activity/compileApplicantsNote`;
// 参与人备注详情接口
const applicantsNoteDetailsUrl = `/gateway/hc-serve/miniapi/activity/applicantsNoteDetails`;
// 根据活动id和日期获取场次列表
const getScheduleListUrl = `/gateway/hc-serve/miniapi/activity/getScheduleList`;
// 根据场次id获取签到详情
const getScheduleSignDetailsUrl = `/gateway/hc-serve/miniapi/activity/getScheduleSignDetails`;
// 活动签到/签出
const signInOrOutUrl = `/gateway/hc-serve/miniapi/activity/signInOrOut`;
export {
  getScheduleSignDetailsUrl,
  signInOrOutUrl,
  getScheduleListUrl,
  getActivityListUrl,
  getActivityDetailUrl,
  addPeopleUrl,
  editPeopleUrl,
  addPeopleListUrl,
  addPeopleDetailUrl,
  deletePeopleUrl,
  applyActivityUrl,
  cancelActivityUrl,
  activityDetailUrl,
  myActivityUrl,
  publishActivityUrl,
  myPublishActivityUrl,
  userInfoUrl,
  areaListUrl,
  volunteerUrl,
  appliyVolunteerUrl,
  getCommitmentLetterDetailsUrl,
  ifCommitmentLetterUrl,
  applyForCommitmentLetterUrl,
  getMyFamilyMemberListUrl,
  addFamilyMemberUrl,
  deleteFamilyMemberUrl,
  compileApplicantsNoteUrl,
  applicantsNoteDetailsUrl,
  activityApplyInfoUrl,
};
